import { compose, withStateHandlers, withHandlers } from 'recompose';
import { actions } from 'react-redux-form';
import { isFunction } from 'lodash';

export default ({ onSubmit, defaultItem } = {}) =>
  compose(
    withStateHandlers(
      props => ({
        form: null,
        item: isFunction(defaultItem) ? defaultItem(props) : defaultItem,
        pending: false,
        dispatch: null,
      }),
      {
        setItem: () => item => ({ item }),
        setForm: () => form => ({ form }),
        setDispatch: () => dispatch => ({ dispatch }),
      }
    ),
    withHandlers({
      change: ({ dispatch }) => (model, value) =>
        dispatch(actions.change(`local.${model}`, value)),
      onUpdate: ({ setForm }) => form => setForm(form),
      onChange: ({ setItem }) => item => setItem(item),
      setDispatch: ({ setDispatch }) => dispatch => setDispatch(dispatch),
      onSubmit: props => (...args) => {
        if (!isFunction(onSubmit)) return null;
        const { dispatch } = props;
        dispatch(actions.setPending('local', true));
        return Promise.resolve(onSubmit(props)(...args)).finally(() =>
          dispatch(actions.setPending('local', false))
        );
      },
    })
  );



// WEBPACK FOOTER //
// ./src/components/common/withForm.js